<mat-card *ngIf="node">
  <mat-card-content>
    <wk-content-metadata
      [displayDefaultProperties]="displayDefaultProperties"
      [expanded]="expanded"
      [node]="node"
      [displayEmpty]="true"
      [multi]="multi"
      [preset]="preset"
      [displayTags]="true"
      [isEditModeInput]="isEditMode"
    >
    </wk-content-metadata>
  </mat-card-content>
</mat-card>
